import React from "react";
import { About } from "../ui/CommonStyles";
import critterMailClubBanner from "../img/mail_club/critter-mail-club.png";

function MailClubPage() {
  return (
    <About className="container">
      <div className="row">
        <div className="col-md-2 col-sm-0" />
        <div className="col-md-8 col-sm-12">
          <div className="thumbnail">
            <img
              src={critterMailClubBanner}
              alt="kendel at show"
              className="image-bio"
            />
          </div>
        </div>
        <div className="col-md-2 col-sm-0" />
      </div>

      <div className="row">
        <div className="col-md-2 col-sm-2 col-xs-0" />
        <div className="col-md-8 col-sm-8 col-xs-12">
          <br />
          <a
            href="https://www.patreon.com/cw/LupineRavenArtworks"
            target="_blank"
            rel="noopener noreferrer"
          >
            <p className="mail-text mail-link join-text">
              Click here for more details!
            </p>
          </a>

          <br />
          <br />

          <p className="bio-text mail-text">
            Hi friends and welcome to the Critter Mail Club, where you can get
            nature inspired artwork mailed to your door every month!
          </p>
          <p className="bio-text mail-text">
            I've always loved the idea of getting monthly goodies in the mail,
            and my goal with the mail club is to bring a bit of extra color +
            joy into your life and home. I hope to connect through a shared love
            for art, animals, and nature, while giving myself an opportunity to
            try new things, experiment with new ideas, and create consistently.
          </p>
          <br />
          <p className="bio-text mail-text mail-text-italic">
            Prints and stickers will both be mailed with a stamp, without
            tracking. <b>US shipping only at this time.</b>
          </p>
        </div>
        <div className="col-md-2 col-sm-2 col-xs-0" />
      </div>
    </About>
  );
}

export default MailClubPage;
